var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 24 20",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.4984 2.6232c-.276-1.032-1.0896-1.8456-2.1216-2.1216-1.872-.50159975-9.3768-.5016-9.3768-.5016s-7.5048.00000025-9.3768.5016c-1.032.276-1.8456 1.0896-2.1216 2.1216-.50160004 1.872-.5016 6.9768-.5016 6.9768s-.00000004 5.1048.5016 6.9768c.276 1.032 1.0896 1.8456 2.1216 2.1216 1.872.5016 9.3768.5016 9.3768.5016s7.5048 0 9.3768-.5016c1.0332-.276 1.8456-1.0896 2.1216-2.1216.5016-1.872.5016-6.9768.5016-6.9768s0-5.1048-.5016-6.9768zm-13.8984 11.1336v-8.3136l7.2 4.1568z",
    fill: "#869ab8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.643c15b5519d9285cbd509ec4bb06c95.svg";
export { ForwardRef as ReactComponent };